<div class="header">
  <h3>My Assignments</h3>
</div>

<div class="p-3 mb-3 bg-bdo-secondary">
  <fieldset>
    <legend>Search My Assignments</legend>
    <div class="form-inline">
      <label for="assignment-code">Engagement Code</label>
      <input id="assignment-code" class="form-control editor-sm ml-2" [(ngModel)]="engagementCode" />
      <label for="assignment-client" class="ml-2">Client Name</label>
      <input id="assignment-client" class="form-control editor-sm ml-2" [(ngModel)]="clientName" />
      <div class="assignment-filter-group">
        <label for="assignment-year">Inspection Year</label>
        <select id="assignment-year" class="custom-select" [(ngModel)]="inspectionYear">
          <option [ngValue]="0">Select All</option>
          @for (year of inspectionYears; track year) { <option [ngValue]="year">{{year}}</option> }
        </select>
      </div>
      <div class="assignment-filter-group">
        <label for="assignment-status">Progress</label>
        <select id="assignment-status" class="custom-select" [(ngModel)]="progressStatus">
          <option value="">All</option>
          @for (status of uow.progressStatuses; track status.status) {
            <option [value]="status.status">{{status.title}}</option>
          }
        </select>
      </div>
      <button type="button" class="btn btn-primary ml-2" (click)="applyFilters()"><i class="fa fa-search"></i> Search</button>
      <button type="button" class="btn btn-secondary ml-2" (click)="clearFilters()"><i class="fa fa-times"></i> Clear</button>
    </div>
  </fieldset>
</div>

<div class="row">
  <div class="col">
    <p><b>{{rowCount}}</b> {{rowCount === 1 ? 'record' : 'records'}} found</p>
    <home-grid-pager [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></home-grid-pager>
    <table class="table table-striped table-align-middle my-2" id="phase8-engagements-grid">
      <thead>
        <tr class="headers-row">
          <th><button class="btn btn-link p-0 text-dark" (click)="setSort('code')">Engagement Code <i class="fa" [ngClass]="getSortIcon('code')"></i></button></th>
          <th><button class="btn btn-link p-0 text-dark" (click)="setSort('clientName')">Client Name <i class="fa" [ngClass]="getSortIcon('clientName')"></i></button></th>
          <th><button class="btn btn-link p-0 text-dark" (click)="setSort('inspectionYear')">Year <i class="fa" [ngClass]="getSortIcon('inspectionYear')"></i></button></th>
          <th><button class="btn btn-link p-0 text-dark" (click)="setSort('progressStatus')">Progress <i class="fa" [ngClass]="getSortIcon('progressStatus')"></i></button></th>
          <th>Assigned Questions</th>
          <th>Completed</th>
          <th>% Complete</th>
        </tr>
      </thead>
      <tbody>
        @if (!activeEngagements.length) {
          <tr><td colspan="7" class="text-center p-3">
            @if (isLoading) { <i class="fa fa-spin fa-refresh text-primary"></i> Please wait while assignments load&hellip; }
            @if (!isLoading) { <i class="fa fa-ban text-danger"></i> No data to display&hellip; }
          </td></tr>
        }
        @for (item of activeEngagements; track item.engagementId) {
          <tr>
            <td><a class="engagment-link" (click)="open(item)">{{item.code || item['engagementCode']}}</a></td>
            <td><a class="engagment-link" (click)="open(item)">{{item.clientName || item['engagementClient']}}</a></td>
            <td>{{item.inspectionYear || item['year']}}</td>
            <td>{{getProgressStatusName(item.progressStatus || item.status)}}</td>
            <td class="text-center">{{item.myAssignedQuestions ?? item.totalQuestions}}</td>
            <td class="text-center">{{item.myCompletedQuestions ?? item.completedQuestions}}</td>
            <td class="text-center">{{progressPercent(item) | percent:'1.0-0'}}</td>
          </tr>
        }
      </tbody>
    </table>
    <home-grid-pager [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></home-grid-pager>
  </div>
</div>
